import { BlazonReward } from 'app/common/modals/blazon/body/rewards/item/BlazonReward'
import { H6 } from 'app/common/typography'
import React from 'react'
import { FormattedMessage } from 'react-intl'
import type { Reward } from 'shared/types'
import styled from 'styled-components'

type Props = {
    reward: Reward
}

const BlazonRewards = (props: Props) => {
    const { reward } = props

    return (
        <Root>
            <H6>
                <FormattedMessage id="kingdom.challenge.rewards.title" />
            </H6>
            <RewardsContainer>
                <BlazonReward reward={reward} />
            </RewardsContainer>
        </Root>
    )
}

const Root = styled.div`
    display: flex;
    flex-direction: column;
    gap: 8px;
`

const RewardsContainer = styled.div`
    display: flex;
    flex-direction: column;
    gap: 8px;
`

export default BlazonRewards
